import {Http} from "@angular/http";
import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Router} from "@angular/router";
import {PaiementDto} from "@resources/resources";


@Component({
  selector: 'rappel-component',
  templateUrl: './rappel.component.html',
  host: {'class': 'page'}
})
export class RappelComponent {
  @Input() paiement: PaiementDto;
  @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();
  showNext: boolean;
  paiementData: string;
  paiementError: boolean = false;

  constructor(private router: Router, private http: Http) {
  }

  next() {
    let paiementIds = [this.paiement.id];
    console.log(paiementIds);

    this.http.post('/paiement-factures/api/paiement/initializeTransaction', paiementIds)
      .map(res => res.text())
      .subscribe(
        data => {
          //console.log(data);
          this.paiementData = data;
          this.paiementError = false;
          this.showNext = true;
        },
        () => {
          this.paiementData = null;
          this.paiementError = true;
          this.showNext = true;
        });
  }

  ngOnInit() {
    this.showNext = false;
    this.paiementData = null;
    this.paiementError = false;
  }

  return(agreed: boolean) {
    this.onReturn.emit(agreed);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/patient/rappel/rappel.component.ts